import { Component, OnInit } from '@angular/core';
import { AlbumDataService } from '../services/album-data.service';

@Component({
  selector: 'app-our-services',
  templateUrl: './our-services.component.html',
  styleUrls: ['./our-services.component.css'],
  providers: [AlbumDataService]
})
export class OurServicesComponent implements OnInit {
  alObj:any;
  constructor(private albumService: AlbumDataService) { }
  
  ngOnInit() {
    var currObj=this;
    this.albumService.getData().subscribe(res => {
      currObj.alObj = res;
    },error => {
      console.log('Something went wrong!!!');
    });
  }

}
